module.exports = __webpack_public_path__ + "static/img/謝謝300.3329a472.png";